import EcosiaUser from '@ecosia/ecosia-user';

import {
  LAST_DISCARDED_NOTIFICATION as LAST_DISCARDED_NOTIFICATION_COOKIE,
  LAST_READ_NOTIFICATION as LAST_READ_NOTIFICATION_COOKIE,
  MAIN as MAIN_COOKIE,
  APP_SNOWPLOW_ID as APP_SP_COOKIE,
} from '~~/common/js/constants/cookies';
import { DEFAULT_LOCALE } from '~~/common/js/constants/i18n';

export const state = () => ({
  addOn: 0,
  autoSuggest: 1,
  bingMarketCode: 'en-us',
  browser: '',
  browserDisplay: '',
  browserVersion: '',
  confirmEmail: '',
  consentGiven: false,
  consentVisible: false,
  defaultMarket: '',
  deviceType: 'pc',
  isEcosiaApp: false,
  language: DEFAULT_LOCALE,
  lastDiscardedNotification: null,
  lastReadNotificationTimestamp: 0,
  lastTree: 0,
  loggedIn: false,
  loginFailed: false,
  newTab: 0,
  notificationEnabled: 1,
  searchesPerTree: 50,
  temperatureUnit: 'auto',
  treeCount: 0,
});

export const getters = {
  linkTarget: ({ newTab }) => (newTab ? '_blank' : '_self'),
  nextTree: ({ treeCount, searchesPerTree }) => Math.round(
    ((treeCount % searchesPerTree) / searchesPerTree) * 100,
  ) / 100,
  treesPlanted: ({ treeCount, searchesPerTree }) => Math.floor(treeCount / searchesPerTree),
};

export const mutations = {
  set(st, data) {
    Object.assign(st, data);
  },
  setConfirmEmail(st, email) {
    st.confirmEmail = email;
  },
  setLoggedIn(st, loggedIn) {
    st.loggedIn = loggedIn;
  },
  setTreeCount(st, treeCount) {
    st.treeCount = treeCount;
  },
};

export const actions = {
  nuxtServerInit({ commit }, context) {
    const { app, req } = context;
    const user = req.user || new EcosiaUser({
      cookieString: app.$cookieManager.get(MAIN_COOKIE),
      userAgent: req.headers['user-agent'],
      acceptLanguage: req.headers['accept-language'],
    });

    const lastDiscardedNotification = app.$cookieManager.get(LAST_DISCARDED_NOTIFICATION_COOKIE);
    const lastReadNotificationTimestamp = app.$cookieManager.get(LAST_READ_NOTIFICATION_COOKIE);

    // Fill the mobile snowplow ID from either query string or cookie, where query param
    // takes precedence and it is persisted as a cookie in core/common/js/utils.js
    const isEcosiaApp = user.get('isEcosiaApp');
    const urlParams = new URLSearchParams(req.url);
    const mobSpParam = urlParams.get('_sp');
    const appUserSnowplowId = (isEcosiaApp && mobSpParam && mobSpParam !== '') ?
      mobSpParam : app.$cookieManager.get(APP_SP_COOKIE);

    const data = {
      addOn: user.get('addOn'),
      appUserSnowplowId,
      autoSuggest: user.get('autoSuggest'),
      bingMarketCode: user.get('bingMarketCode'),
      browser: user.get('browser'),
      browserDisplay: user.get('browserDisplay'),
      browserVersion: user.get('browserVersion'),
      consentGiven: app.$cookieManager.getConsentGiven(),
      defaultMarket: user.get('bingMarketCode'),
      deviceType: user.get('deviceType'),
      isEcosiaApp,
      language: user.get('language'),
      lastDiscardedNotification,
      lastReadNotificationTimestamp,
      lastTree: user.get('lastTree'),
      loggedIn: req.loggedIn,
      loginFailed: req.loginFailed,
      newTab: user.get('newTab'),
      notificationEnabled: user.get('notifications'),
      temperatureUnit: user.get('temperatureUnit'),
      treeCount: user.get('treeCount'),
    };

    commit('set', data);
  },
};

export const storeModule = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default (store) => {
  store.registerModule('user', storeModule);
};
